// extracted by mini-css-extract-plugin
export default {"container":"testCaseTemplates_container__6goyq","arrow":"testCaseTemplates_arrow__N6C5f","active":"testCaseTemplates_active__DmhTw","testCases":"testCaseTemplates_testCases__vUbN6"};